<style  lang="less">
      @import './less/login.less';
      @import "../operations/less/showmodel.less";
      @import "../../styles/public/public.less";
        input:-webkit-autofill , textarea:-webkit-autofill, select:-webkit-autofill {
            -webkit-box-shadow: 0 0 0px 1000px rgb(26,76,115) inset;
            border: 1px solid rgb(23,112,142)!important;
            -webkit-text-fill-color: #0ae3e1;
    }
</style>
<template>
    <div class="login_1 public_noxy">
        <div class="login_2 "></div>
        <div class=" public_y login_tup " >
            <div class="dispaly_flex11 login_sz display_row_jc_ac" style="height:180px;">
                <img  :src="url.url_1">
            </div>
            <div style="display:flex;flex-direction:column;height: calc(100% - 180px);justify-content: center;">
                <div style="display: flex;justify-content: center;max-height: 600px;">
                    <div  v-show="loginPage[0].flag" class="public_pop_hz login_hz dispaly_flex00">
                        <div class="login_welcome display_row_jc_ac">
                            <div class="login_welcome_title">账号登录</div>
                        </div>
                        <input type="text" class="login_name" v-model="username" @keypress.enter="login()"/>
                        <input type="password" class="login_pwd" v-model="password" @keypress.enter="login()"/>
                        <input type="button" value="登  录" class="login_btn" @click="login()"/>
                        <div class="login_tip display_row_js_ac">
                        <div class="forget_password display_row_ac">
                            <div class="login_tip_badge display_row_jc_ac">?</div>
                            <span class="tip_forget">忘记密码?</span>
                            <div class="ogin_tip_badgema display_row_jc_ac" @click="mima()" >
                                <img v-show="flog" src="./images/gx.png">
                            </div>
                            <span  class="ogin_tip_badgemas" @click="mima()" > 记住密码</span>
                        </div>
                        <p><span class="login_tip_regist">还没有帐号? </span><span @click="changePage(1)" class="regist_click">点击注册</span></p>
                        </div>
                    </div>
                    <div v-show="loginPage[1].flag" class="dispaly_flex00" style="margin-bottom: 20px;">
                        <registeredss ></registeredss>
                    </div>
                    <div v-if="loginPage[2].flag" class="dispaly_flex00" style="margin-bottom: 20px;">
                        <companyregistered  ></companyregistered>
                    </div>
                </div>            
                <div  class="dispaly_flex00 login_wz display_column_ac">
                    <p>{{names.names_1}}</p>
                    <p>{{names.names_2}}</p>
                </div>
            </div>
            
            <!-- <div  class="dispaly_flex11 login_sz">
            </div> -->
        </div>
    </div>
</template>
<script>
    import bus from "../../app/event"; 
    import Cookies from "js-cookie";
    import registeredss from "./registered.vue";
    import companyregistered from "./companyregistered.vue";
    export default {
        components: {
            registeredss,
            companyregistered
        },
        data() {
            return {
                unitname:'',
                flog:false,
                username:"",
                password:"",
                url:{
                    url_1:"./static/images/bt.png",
                    url_2:"./static/img/1.d6d644a.png",
                    url_3:"./static/images/返回.png",
                },
                names:{
                    names_1:"版权所有：南京市绿化园林局",
                    names_2:"技术支持：南京市测绘勘察研究院股份有限公司",
                },

                loginPage:[
                    {
                        flag:true
                    },
                    {
                        flag:false
                    },
                    {
                        flag:false
                    },
                ],
            };
        },
        watch: {
            },
        methods: {
            //切换登陆页面
            changePage:function(index){
                this.loginPage.forEach(ele => {
                    ele.flag=false;
                });
                this.loginPage[index].flag=true;
                index==2?bus.$emit('refreshreg'):null;//如果返回注册用户页面就重新获取单位数据
            },
            login:function(){
                if (this.username == "" || this.password == "" ) {
                    this.$Message.info('用户名，密码不能为空');
                    return
                }
                var Base64 = require('js-base64').Base64; 
              //  var password_1 =  Base64.encode(this.password)
                this.$http({
                    method: 'post',
                    url: appurl.ip + "/ylkjservice/services/hander.ashx",
                    data: {
                        action:"list",
                        UserCode:this.username,
                        Psw:this.password,
                    }
                })
                .then(function (success) {
                    if (success.data.success == "false") {
                            this.$Message.error("用户名密码错误");
                            return
                    }else{
                        var Base64 = require('js-base64').Base64; 
                        //记录到当前页面
                        sessionStorage.setItem("flog",true);
                        sessionStorage.setItem("ID",success.data.ID);
                        sessionStorage.setItem("SSDW",success.data.SSDW);
                        sessionStorage.setItem("AOTHOR_ID",success.data.AOTHOR_ID); 
                        sessionStorage.setItem("ISADMIN",success.data.ISADMIN);
                        sessionStorage.setItem("USERCODE",success.data.USERCODE);
                        sessionStorage.setItem("USERNAME",success.data.USERNAME);
                        sessionStorage.setItem("EXPERT",success.data.EXPERT);
                        if (this.flog == true) {
                            //记录到localStorage 相当如cooke
                            var dest = {
                                username:this.username,
                                password:this.password,
                            }
                            var jso = JSON.stringify(dest); 
                            localStorage.setItem("flog",true);
                            localStorage.setItem("user",Base64.encode(jso));
                        }else{
                            //清除这个
                            localStorage.removeItem("flog")
                            localStorage.removeItem("user")
                        }
                        this.assignment(success.data);
                    }
                }.bind(this))
                .catch(function (response) {
                    this.$Message.error('请求失败查询网络是否畅通！');
                }.bind(this))
            },
            assignment:function(item){
                this.$store.state.user = item;
                
                //kooken,里面赛制
                this.cooke(item);
            },
            //ccoken，里面赛制
            cooke:function(item){
                var Base64 = require('js-base64').Base64; 
                var dest = {
                    id:item.ID,
                    username:this.username,
                    password:this.password,
                    SSDW:item.SSDW,
                    AOTHOR_ID:item.AOTHOR_ID,
                    ISADMIN:item.ISADMIN,
                    USERCODE:item.USERCODE,
                    USERNAME:item.USERNAME,
                    EXPERT:item.EXPERT
                }
                var jso =  JSON.stringify(dest); 
                var user =  Base64.encode(jso)
                Cookies.set("flog", true);
                Cookies.set("user", user);
                var  name = Cookies.get("flog");
                var  namess = Cookies.get("user");

                this.$store.state.app = "man";
            },
            mima:function(){
                this.flog = !this.flog 
            },
            localStorage_mima:function(){
                var Base64 = require('js-base64').Base64; 
                var jso  = Base64.decode(localStorage.getItem("user")) 
                var dest = JSON.parse(jso); 
                this.username= dest.username;
                this.password= dest.password;
            },
        },
        mounted() {
            
            if (localStorage.getItem("flog") == undefined || localStorage.getItem("flog") ==  null ) {
                this.flog = false;
            }else{
                this.flog = true;
                this.localStorage_mima()
            }
            bus.$on('showunit_login',(item)=>{
                this.changePage(item);
            })

        },
        beforeDestroy(){
            bus.$off('showunit_login');
        },
        destoryed:function(){
        },
    };
</script>


// WEBPACK FOOTER //
// login.vue?2e634823